<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal ref="modal" :title="title" no-close-on-backdrop @ok="ok($event)" @cancel="close()" @close="close()">
        <div class="edit-plot-content">
            <div class="edit-plot-line">
                <div class="edit-plot-label">名称：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.name"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">类型：</div>
                <div class="edit-plot-input">
                    <select class="form-control" v-model="plot.type">
                        <option v-for="type in plotTypes" :key="type.id" :value="type.type">{{type.type}}</option>
                    </select>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">别名：</div>
                <div class="edit-plot-input edit-plot-aliases">
                    <div class="edit-plot-alias" v-for="(alias, index) in plot.aliases">
                        <div class="edit-plot-input">
                            <input class="form-control" v-model="plot.aliases[index]"/>
                        </div>
                        <button class="btn btn-outline-danger edit-plot-icon" @click="removeAlias(index)">
                            <font-awesome-icon icon="minus"/>
                        </button>
                    </div>
                    <div class="edit-plot-alias">
                        <div class="edit-plot-input"></div>
                        <button class="btn btn-outline-primary edit-plot-icon" @click="addAlias()">
                            <font-awesome-icon icon="plus"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">所属河流：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.river"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">里程刻度：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.cursor"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">备注：</div>
                <div class="edit-plot-input">
                    <textarea class="form-control edit-plot-note" v-model="plot.note"></textarea>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <div class="w-100 d-flex align-items-center justify-content-between m-0">
                <div>
                    <b-button v-if="isEdit" class="m-1" variant="danger" @click="remove()">删除点标绘</b-button>
                </div>
                <div class="form-inline">
                    <b-button class="m-1" variant="outline-primary" @click="cancel()">取消</b-button>
                    <b-button class="m-1" variant="primary" @click="ok()">确定</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import * as MsgBox from "../utils/msgBox";
import User from "../services/user";
import Plot from "../services/plot";
import {plotTypes} from "../olMap/featureUtils";

const defaultPlot = {
    name: "",
    river: "",
    cursor: null,
    type: "地标",
    note: "",
    aliases: [],
};

export default {
    name: "EditPlotDialog",
    data() {
        return {
            plot: defaultPlot,
            plotTypes: [],
        };
    },
    computed: {
        isEdit() {
            return this.plot && this.plot.id;
        },
        isAdmin() {
            return User.user && User.user.admin;
        },
        title() {
            return (this.isEdit ? "编辑" : "新建") + "标绘";
        },
    },
    methods: {
        modal(plot) {
            this.plotTypes = plotTypes.filter(
                x => x.category === "point" && (this.isAdmin ? x.adminEditable : x.userEditable)
            );
            this.plot = plot ? {
                id: plot.id || 0,
                name: plot.name || null,
                river: plot.river || null,
                cursor: (plot.cursor === void (0) || plot.cursor === null) ? null : plot.cursor.toString(),
                type: plot.type || "地标",
                note: plot.note || null,
                aliases: (plot.aliases || []).slice(),
                lon: plot.lon,
                lat: plot.lat,
            } : Object.assign({}, defaultPlot);
            return new Promise(resolve => {
                this.resolve = resolve;
                this.$refs.modal.show();
            });
        },
        close() {
            this.resolve && this.resolve();
        },
        async ok(e) {
            e.preventDefault();
            if (!(this.plot.name && this.plot.name.trim())) {
                return await MsgBox.alert(this, "名称不能为空！");
            }
            let plot = {
                id: this.plot.id || 0,
                name: this.plot.name,
                river: this.plot.river,
                cursor: (this.plot.cursor && this.plot.cursor.trim()) ? +this.plot.cursor : null,
                type: this.plot.type,
                note: this.plot.note,
                aliases: this.plot.aliases.filter(x => x).map(x => x.trim()),
                lon: this.plot.lon,
                lat: this.plot.lat,
            };
            let error = null;
            let onError = async e => {
                error = e;
                if (e && e.isAxiosError && e.response.status >= 400 && e.response.status < 500) {
                    MsgBox.alert(this, e.response.data || "", {title: "错误"});
                } else {
                    throw e;
                }
            };
            plot.id = await Plot.save(plot, onError);
            if (!error) {
                this.onResult(plot);
            }
        },
        async remove() {
            if (await MsgBox.confirm(this, `确认要删除点标绘“${this.plot.name}”？`)) {
                await Plot.remove(this.plot.id);
                this.onResult(null);
            }
        },
        onResult(plot) {
            this.resolve && this.resolve(plot);
            this.$refs.modal.hide();
        },
        addAlias() {
            this.plot.aliases.push("");
        },
        async removeAlias(index) {
            let alias = (this.plot.aliases[index] || "").trim();
            if (!alias || await MsgBox.confirm(this, `确认要删除别名“${alias}”？`)) {
                this.plot.aliases.splice(index, 1);
            }
        },
    },
}
</script>

<style scoped>
.edit-plot-content > * + *,
.edit-plot-aliases > * + * {
    margin-top: 0.5rem;
}

.edit-plot-line {
    display: flex;
    align-items: stretch;
}

.edit-plot-label {
    text-align: right;
    min-width: 100px;
    margin-right: 0.5rem;
    line-height: calc(1.5em + 0.75rem + 2px);
}

.edit-plot-input {
    flex: 1;
}

.edit-plot-note {
}

.edit-plot-alias {
    display: flex;
    align-items: center;
}

.edit-plot-icon {
    margin-left: 0.5rem;
}
</style>
